import { Alert, AlertIcon, Box, CloseButton, HStack, Link, Stack, Text } from '@chakra-ui/react';
import { on } from 'http-proxy';
import React, { useContext } from 'react';
import { UserContext } from '../../providers';
import { NavLink } from 'react-router-dom'

export const DiscountedPricingAlertBox = () => {
    const { user } = useContext(UserContext)

    if (!user) return null

    const { isEligibleForDiscountedPricing, discountedPricingThresholdUSD, canAddCreditBalance } = user

    if (isEligibleForDiscountedPricing) {
        return (
            <Alert status="warning">
                <AlertIcon />
                <Stack direction={['column']} spacing="0.75em">
                    <Box>
                        Your charges for the upcoming month have exceeded ${discountedPricingThresholdUSD}. You are eligible for a discounted pricing plan. Please check your inbox for more information or email us at <Link href="mailto:support@imagekit.io">support@imagekit.io</Link>.
                    </Box>
                </Stack>
            </Alert>
        )
    }

    if (canAddCreditBalance) {
        return (
            <Alert status="warning">
                <AlertIcon />
                <Stack direction={['column']} spacing="0.75em">
                    <Box>
                        Save 15% by paying upfront. <Link as={NavLink} to="/billing/credit-balance">Add credit balance</Link>.
                    </Box>
                </Stack>
            </Alert>
        )
    }

    return null;
}

export const DiscountedPricingClosableInfoBar = () => {
    const { user } = useContext(UserContext)

    if (!user) return null

    const { isEligibleForDiscountedPricing, discountedPricingThresholdUSD } = user

    if (!isEligibleForDiscountedPricing) return null

    const [showInfoBar, setShowInfoBar] = React.useState(false);

    // Check if the annoucement is closed in the last 24 hours
    React.useEffect(() => {
        const discountedPricingNotificationClosed = localStorage.getItem('discountedPricingNotificationClosed');
        if (discountedPricingNotificationClosed) {
            const { closed, timestamp } = JSON.parse(discountedPricingNotificationClosed);
            if (closed && (Date.now() - timestamp) < 24 * 60 * 60 * 1000) {
                setShowInfoBar(false);
                return;
            }
        }
        setShowInfoBar(true)
    }, []);

    const handleClose = (e) => {
        e.preventDefault();
        setShowInfoBar(false);
        localStorage.setItem('discountedPricingNotificationClosed', JSON.stringify({
            closed: true,
            timestamp: Date.now()
        }));
    };

    return (
        <>
            {showInfoBar &&
                <Alert status="warning" borderRadius={"0"} borderTop={0} borderLeft={0} borderRight={0}>
                    <AlertIcon />
                    <Text>
                        Your charges for the upcoming month have exceeded ${discountedPricingThresholdUSD}. You are eligible for a discounted pricing plan. Please check your inbox for more information or email us at <Link href="mailto:support@imagekit.io">support@imagekit.io</Link>.
                    </Text>
                    <CloseButton onClick={handleClose} position={"absolute"} right={10} />
                </Alert>
            }
        </>
    )
}